// rails
// images
// style
import '../../../stylesheets/front/pc/application';
import PcRoutablePageSlideUpDown from '../../../src/front/pc/routable_page/SlideUpDown';
import PcInstitutionMoreDisplayCard from '../../../src/front/pc/institution/MoreDisplayCard';
import PcInstitutionMoreDisplayYokarepo from '../../../src/front/pc/institution/MoreDisplayYokarepo';
import PcInstitutionSmoothScroll from '../../../src/front/pc/institution/SmoothScroll';
import PcFeaturesSearchDoctorsResultNaviMore from '../../../src/front/pc/features/search/doctors/ResultNaviMore';
import PcFeaturesSearchDoctorsAreaSlideUpDown from '../../../src/front/pc/features/search/doctors/AreaSlideUpDown';
import PcFeaturesSearchDoctorsProfileImageCarousel from '../../../src/front/pc/features/search/doctors/ProfileImageCarousel';
import PcFeaturesSearchDoctorsContentMore from '../../../src/front/pc/features/search/doctors/ContentMore';

window.PcRoutablePageSlideUpDown = PcRoutablePageSlideUpDown;
window.PcInstitutionMoreDisplayCard = PcInstitutionMoreDisplayCard;
window.PcInstitutionMoreDisplayYokarepo = PcInstitutionMoreDisplayYokarepo;
window.PcInstitutionSmoothScroll = PcInstitutionSmoothScroll;
window.PcFeaturesSearchDoctorsResultNaviMore = PcFeaturesSearchDoctorsResultNaviMore;
window.PcFeaturesSearchDoctorsAreaSlideUpDown = PcFeaturesSearchDoctorsAreaSlideUpDown;
window.PcFeaturesSearchDoctorsProfileImageCarousel = PcFeaturesSearchDoctorsProfileImageCarousel;
window.PcFeaturesSearchDoctorsContentMore = PcFeaturesSearchDoctorsContentMore;

require('@rails/ujs').start();

const images = require.context('../../../images/front', true);
const imagePath = (name) => images(name, true); // eslint-disable-line no-unused-vars

// javascript
const componentRequireContext = require.context('components', true);
const ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(componentRequireContext);
